import React from "react";
import {alpha, Box, keyframes} from "@mui/material";

const scroll = keyframes`
    0% {
        transform: translate3d(0, 0, 0);
    }

    100% {
        transform: translate3d(-100%, 0, 0);
    }
`;

export interface ScrollingLogoMarqueeProps {
    logos?: React.ReactNode[];
    speed?: number;
    gap?: number;
    backgroundColor: string;
}

export const ScrollingLogoMarquee = ({ logos, speed = 10, gap = 50, backgroundColor }: ScrollingLogoMarqueeProps) => (
    <Box
        sx={{
            position: "relative",
            display: "flex",
            overflow: "hidden",
            width: "100%",
            maxWidth: "100vw",
            py: 2,
            backgroundColor,
            "&:before, &:after": {
                content: '""',
                position: "absolute",
                zIndex: 1000,
                top: 0,
                left: 0,
                width: "15rem",
                height: "100%",
                backgroundImage: `linear-gradient(to right, ${alpha(backgroundColor, 1)}, transparent)`
            },
            "&:after": {
                left: "auto",
                right: 0,
                backgroundImage: `linear-gradient(to left, ${alpha(backgroundColor, 1)}, transparent)`
            },
            "&:hover div": {
                animationPlayState: "paused"
            }
        }}
    >
        {[1, 2, 3, 4].map((ri) => (
            <Box
                key={ri}
                data-cy="moving-strip"
                sx={{
                    display: "flex",
                    flexShrink: 0,
                    gap,
                    paddingRight: gap,
                    justifyContent: "space-around",
                    animation: `${scroll} ${speed}s linear infinite`,
                    width: "fit-content",
                    height: {
                        xs: 32,
                        lg: 80
                    }
                }}
            >
                {logos?.map((logo, idx) => (
                    <Box
                        key={idx}
                        sx={{
                            flex: "0 0 auto",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            "& img": {
                                height: "200%",
                                width: "auto"
                            }
                        }}
                    >
                        {logo}
                    </Box>
                ))}
            </Box>
        ))}
    </Box>
);
